import { render, staticRenderFns } from "./BotChatForm.vue?vue&type=template&id=ff0f14c2&scoped=true&"
import script from "./BotChatForm.vue?vue&type=script&lang=js&"
export * from "./BotChatForm.vue?vue&type=script&lang=js&"
import style0 from "./BotChatForm.vue?vue&type=style&index=0&id=ff0f14c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff0f14c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff0f14c2')) {
      api.createRecord('ff0f14c2', component.options)
    } else {
      api.reload('ff0f14c2', component.options)
    }
    module.hot.accept("./BotChatForm.vue?vue&type=template&id=ff0f14c2&scoped=true&", function () {
      api.rerender('ff0f14c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/ChatBot/BotChatForm.vue"
export default component.exports